import { createContext, useContext, type ReactNode } from 'react';
import { container, type DependencyContainer } from 'tsyringe';

const ContainerContext = createContext<DependencyContainer>(container);

/**
 * Provides a DI sub-container scoped to a route.
 * Child components can resolve route-specific dependencies that are
 * isolated from other routes.
 */
interface RouteContainerProviderProps {
    children: ReactNode;
    registrations?: (childContainer: DependencyContainer) => void;
}

export function RouteContainerProvider({ children, registrations }: RouteContainerProviderProps) {
    const parentContainer = useContext(ContainerContext);
    const childContainer = parentContainer.createChildContainer();

    if (registrations) {
        registrations(childContainer);
    }

    return <ContainerContext.Provider value={childContainer}>{children}</ContainerContext.Provider>;
}

export function useDIContainer(): DependencyContainer {
    return useContext(ContainerContext);
}
